<template>
  <div>
    <b-card :title="capitalize($t('leadSources'))">
      <!--    <h1>{{ capitalize($t('opportunityMarketingRate')) }}</h1>-->

      <vue-apex-charts
          :options="chartOptions"
          :series="series"
      />
    </b-card>
  </div>
</template>

<script>
import { ref, computed, watch }          from '@vue/composition-api'
import { capitalize, currency, percent } from '../../../../../../utils/filter'

import VueApexCharts from 'vue-apexcharts'
import i18n          from '../../../../../../libs/i18n'

import IndicatorEvolution from '../../../../../../components/indicatorEvolution/IndicatorEvolution.vue'

export default {
  components: { VueApexCharts, IndicatorEvolution },
  props: {
    opportunitiesMarketingRateChart: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const isReady = computed(() => {
      return !(Object.keys(props.opportunitiesMarketingRateChart).length === 0 && props.opportunitiesMarketingRateChart.constructor === Object)
    })

    const labels = computed(() => {
      let output = []
      for (const key in props.opportunitiesMarketingRateChart.chart) {
        output.push(capitalize(i18n.tc(getMarketingKeyLabel(key,2))))
      }
      return output
    })

    const series = computed(() => {
      let output = []
      for (const key in props.opportunitiesMarketingRateChart.chart) {
        output.push(props.opportunitiesMarketingRateChart.chart[key].value)
      }
      return output
    })

    const chartOptions = computed(() => {
      return {
        chart: {
          type: 'donut',
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: { show: false },
        labels: isReady.value ? labels.value : [],
        stroke: { width: 0 },
        // colors: ["#28C76F", "rgba(40,199,111,0.7)", "rgba(40,199,111,0.5)", "rgba(40,199,111,0.16)"],
        grid: {
          padding: {
            right: -20,
            bottom: -8,
            left: -20,
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  offsetY: 15,
                },
                value: {
                  offsetY: -15,
                  formatter (val) {
                    return percent(val, 0)
                    // return currency(val, true)
                  },
                },
                total: {
                  show: true,
                  offsetY: 15,
                  formatter (w) {
                    const total = w.globals.seriesTotals.reduce((a, b) => { return a + b }, 0)

                    return percent(total, 0)
                  },
                },
              },
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return percent(val, 0)
            }
          }
        },
        responsive: [
          {
            breakpoint: 1325,
            options: {
              chart: {
                height: 100,
              },
            },
          },
          {
            breakpoint: 1200,
            options: {
              chart: {
                height: 120,
              },
            },
          },
          {
            breakpoint: 1045,
            options: {
              chart: {
                height: 100,
              },
            },
          },
          {
            breakpoint: 992,
            options: {
              chart: {
                height: 120,
              },
            },
          },
        ],
      }
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const getMarketingKeyLabel = (marketingKey) => {
      switch (marketingKey) {
        case 'Internet research':
          return 'internetResearch'
        case 'Social networking':
          return 'socialNetworking'
        case 'Press':
          return 'press/media'
        case 'Network':
          return 'network'
        case 'Newsletter':
          return 'newsletter'
        case 'Event':
          return 'event'
        case 'Farming':
          return 'farming'
        case 'No source':
          return 'noSource'
      }
    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed
      isReady,
      series,
      chartOptions,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: { percent, capitalize },
  mounted () {
  },
  created () {
  }
}
</script>

<style
    scoped
    lang="scss"
>

</style>